import logo2020 from "../../assets/img/nxtEvents/LogoIYH/InYourHouse.png";
import logo2021 from "../../assets/img/nxtEvents/LogoIYH/InYourHouse2021.png";
import logo2022 from "../../assets/img/nxtEvents/LogoIYH/InYourHouse2022.png";

export const nxtInYourHouseDetail = {
  "nxt-in-your-house": {
    id: "nxt-in-your-house",
    title: "NXT In Your House",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "nxt-in-your-house",
        items: [
          {
            id: "nxt-in-your-house-2020",
            title: "TakeOver",
            description: "In Your House 2020",
            imgUrl: logo2020,
          },
          {
            id: "nxt-in-your-house-2021",
            title: "TakeOver",
            description: "In Your House 2021",
            imgUrl: logo2021,
          },
          {
            id: "nxt-in-your-house-2022",
            title: "In Your House",
            description: "2022",
            imgUrl: logo2022,
          },
        ],
      },
    ],
  },
};
